import React, { Component } from 'react';

class FeatureLeft extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collLeft: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Proven Tax-Saving Strategies',
                    text: 'Learn legitimate methods to reduce your tax burden.'
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'Maximize Deductions',
                    text: 'Unlock hidden deductions and exemptions you might be missing out on.'
                },
            ]
        }
    }

    render() {
        return (
            <div className="topic-items">
                {
                    this.state.collLeft.map((data, i) => (
                        <div className="topic-item" key={i}>
                            <div className="icon-box">
                                <i className={data.icon}></i>
                            </div>
                            <div className="topic-content">
                                <h4>{data.title}</h4>
                                <p>{data.text}</p>
                            </div>
                        </div>

                    ))
                }
            </div>
        );
    }

}

export default FeatureLeft;
